import {$, w} from './constants';

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');
    if($(".bg-dk").length){
        if($(window).width() < 968){
            $(".bg-dk").css("background-image", "url(" + bgM + ")");
        }else if($(window).width() > 968){
            $(".bg-dk").css("background-image", "url(" + bgD + ")");
        }
    }
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');
})

// ____ M E N Ú ____
const lista = document.querySelector(".menu-responsive");
const clickHamburger = document.getElementById("clickHamburger")

lista.addEventListener("click", mobileMenu );
clickHamburger.addEventListener("click", mobileMenu );

function mobileMenu() {
    lista.classList.toggle("active");
    if(clickHamburger.childNodes[1].classList.contains("close")){
        clickHamburger.childNodes[1].className = "bar animate"
    }else{
        clickHamburger.childNodes[1].className = "close animate"
    }
}

// ____ S L I D E ____

$('#id_slide').slick({
    responsive: [
        {
          breakpoint: 768,
          settings: {
              dots: true,
              arrows: false,
              infinite: true,
              speed: 300,
              slidesToShow: 1
          }
        }]
 });

 if($('#redes-home').length == 1){
     $('#clickHamburger').css('left', '14rem');
     $('#clickHamburger').css('top', '4rem');
 }

 if($('#redes-home').length == 1){
    $('header').css('padding-top', '0');
 }

 $(".playlist").click(function() {
    $(".embed-iframe").show();
    $(".playlist").hide();
    console.log('click');
});
 
// ____ R E S Y ____
const configResy = {"venueId":42298,"apiKey":"pRFv9JtTLwZfYvuzYxb2z1IbaH7HEEW8","replace":false,};
$('.resy_btn_trigger').on('click', function(){
    resyWidget.openModal(configResy);
    console.log('entro active')
});

// ____ T R I P L E S E A T ___ //
$('.open_pop').on('click', function(){
    $('#tripleseat_pop').fadeIn(300).addClass('show');
});
$('#close_pop').on('click', function(){
    $('#tripleseat_pop').fadeOut(300).removeClass('show');
})

// ____ A B O U T ____

$('#scroll_down').on('click', function(){
    $('html, body').animate({
        scrollTop: $('#scroll_target').offset().top
    }, 1000);
});

// ____ S O N G ____
var context = new AudioContext();
context.resume().then(() => {
    $('.button-play').removeClass("active")
});

$('.button-play').on('click', function(){
    if($(this).hasClass('active')){
        $('.button-play').parent().siblings('audio')[0].play();
        $(this).removeClass('active')
    }else{
        $('.button-play').parent().siblings('.song')[0].pause()
        $(this).addClass('active')
    }
});
